import * as sortHelpers from '../sort'
import snakeCase from 'lodash/snakeCase'
import { OrderedSet, List } from 'immutable'

export const addPrefixToActionTypeKey =
  (prefix: string) =>
  (str: string = '') =>
    `${snakeCase(prefix).toUpperCase()}_${snakeCase(str).toUpperCase()}`

export const addPrefixToActionTypeName =
  (prefix: string, delimiter: string = '/') =>
  (str: string) =>
    `${snakeCase(prefix).toUpperCase()}${delimiter}${snakeCase(str).toUpperCase()}`

export const getSortFuncForSelector = sortFields => (all, ids, by: string, desc: boolean) => {
  if (!by) {
    return ids
  }
  return OrderedSet(
    all
      .sortBy(
        value => value.get(by),
        (a, b) => {
          // eslint-disable-next-line no-prototype-builtins
          if (sortFields !== null && sortFields !== undefined && sortFields.hasOwnProperty(by)) {
            // eslint-disable-line no-prototype-builtins
            switch (sortFields[by]) {
              case 'number':
                return sortHelpers.byNumber(a, b, desc)
              case 'boolean':
                return sortHelpers.byBoolean(a, b, desc)
              case 'string':
                return sortHelpers.byString(a, b, desc)
              default:
                return 0
            }
          }
          return 0
        }
      )
      .keySeq()
      .map(key => parseInt(key))
  )
}

export const getListFuncForSelector = (all, ids) => List(ids.map(id => all.get(id.toString())))
